import dynamic from "next/dynamic";
import { useIntersectionObserver } from "usehooks-ts";

import DispensaryCard, {
  DispensaryCardProps,
} from "@/components/botanic/DispensaryCard/DispensaryCard";

const PickupReadinessLabel = dynamic(
  () => import("@/components/botanic/DispensaryCard/PickupReadinessLabel"),
);

const LazyLoadPickupReadinessLabel = ({
  dispensaryId,
}: {
  dispensaryId: DispensaryCardProps["dispensaryId"];
}) => {
  const { ref, isIntersecting } = useIntersectionObserver({
    freezeOnceVisible: true,
  });

  return (
    <span ref={ref}>
      {isIntersecting && <PickupReadinessLabel dispensaryId={dispensaryId} />}
    </span>
  );
};

export const PickupReadinessDispensaryCard: React.FC<DispensaryCardProps> = ({
  dispensaryId,
  onClick,
  ...otherProps
}) => {
  return (
    <DispensaryCard
      dispensaryId={dispensaryId}
      renderReadinessLabel={() => (
        <LazyLoadPickupReadinessLabel dispensaryId={dispensaryId} />
      )}
      {...otherProps}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
    />
  );
};

export default PickupReadinessDispensaryCard;
